import createStore from "@/utils/create-store";
import Model from "@/models/admin/trees";

export default createStore({ Model });
